import EditableCustomizableAutoComplete from 'Global/Components/EditableComponents/EditableCustomizableAutoComplete/EditableCustomizableAutoComplete';
import EditableCustomizableSelect from 'Global/Components/EditableComponents/EditableCustomizableSelect/EditableCustomizableSelect';
import EditableMuiDatePicker from 'Global/Components/EditableComponents/EditableMuiDatePicker/EditableMuiDatePicker';
import EditablePersianSupportTextField from 'Global/Components/EditableComponents/EditablePersianSupportTextField';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import i18next from 'i18next';
import React from 'react';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';

const useGenerateFormData = (
  addPatientParams,
  gatheredData
) => {
  // console.log('gatheredData--->', {
  //   gatheredData,
  //   addPatientParams,
  // });

  const formData = [
    {
      element: (
        <EditablePersianSupportTextField
          label={FindLangKey('lab-patient-name-patient')}
          isEnglish={i18next?.language === 'en'}
          Initialvalue={
            ArabicToPersian(gatheredData?.FirstName) || ''
          }
        />
      ),
      name: 'FirstName',
      required: true,
    },
    {
      element: (
        <EditablePersianSupportTextField
          label={FindLangKey('lab-patient-family-patient')}
          isEnglish={i18next?.language === 'en'}
          Initialvalue={
            ArabicToPersian(gatheredData?.LastName) || ''
          }
        />
      ),
      name: 'LastName',
      required: true,
    },
    {
      element: (
        <EditablePersianSupportTextField
          label={FindLangKey(
            'complete-user-information-input-father-name'
          )}
          isEnglish={i18next?.language === 'en'}
          Initialvalue={
            ArabicToPersian(gatheredData?.FatherName) || ''
          }
        />
      ),
      name: 'FatherName',
      required: true,
    },
    {
      element: (
        <EditablePersianSupportTextField
          label={FindLangKey(
            'save-patients-for-visit-form-input-national-code'
          )}
          isEnglish={i18next?.language === 'en'}
          Initialvalue={gatheredData?.NationalCode || ''}
        />
      ),
      name: 'NationalCode',
      required: true,
    },
    {
      element: (
        <EditablePersianSupportTextField
          label={FindLangKey(
            'general-public-mobile-number'
          )}
          isEnglish={i18next?.language === 'en'}
          Initialvalue={gatheredData?.Mobile || ''}
        />
      ),
      name: 'Mobile',
      required: true,
    },

    {
      element: (
        <EditableCustomizableSelect
          enableInitialOnchange={true}
          label={FindLangKey('general-public-word-gender')}
          isEnglish={i18next?.language === 'en'}
          isSingle={true}
          SelectableDataArray={addPatientParams?.GenderList?.map(
            (el) => ({
              ItemContent: ArabicToPersian(el.Name),
              ItemValue: el.Id,
            })
          )}
          initialData={
            gatheredData
              ? [
                  {
                    ItemContent: ArabicToPersian(
                      addPatientParams?.GenderList?.filter(
                        (fl) =>
                          fl.Id === gatheredData?.IdGender
                      )[0]?.Name
                    ),
                    ItemValue: ArabicToPersian(
                      addPatientParams?.GenderList?.filter(
                        (fl) =>
                          fl.Id === gatheredData?.IdGender
                      )[0]?.Name
                    ),
                  },
                ]
              : addPatientParams?.GenderList?.filter(
                  (fl) =>
                    fl.Id ===
                    addPatientParams?.idGenderDefult
                )[0]?.Name
              ? [
                  {
                    ItemContent: ArabicToPersian(
                      addPatientParams?.GenderList?.filter(
                        (fl) =>
                          fl.Id ===
                          addPatientParams?.idGenderDefult
                      )[0]?.Name
                    ),
                    ItemValue: ArabicToPersian(
                      addPatientParams?.GenderList?.filter(
                        (fl) =>
                          fl.Id ===
                          addPatientParams?.idGenderDefult
                      )[0]?.Name
                    ),
                  },
                ]
              : null
          }
        />
      ),
      name: 'IdGender',
      required: true,
    },
    {
      element: (
        <EditableCustomizableSelect
          enableInitialOnchange={true}
          label={FindLangKey(
            'save-patients-for-visit-form-input-marriage-state'
          )}
          isEnglish={i18next?.language === 'en'}
          isSingle={true}
          SelectableDataArray={addPatientParams?.TaaholList?.map(
            (el) => ({
              ItemContent: ArabicToPersian(el.Name),
              ItemValue: el.Id,
            })
          )}
          initialData={[
            {
              ItemContent: ArabicToPersian(
                addPatientParams?.TaaholList?.filter(
                  (fl) =>
                    fl.Id ===
                    addPatientParams?.idTaaholDifault
                )[0]?.Name
              ),
              ItemValue: ArabicToPersian(
                addPatientParams?.TaaholList?.filter(
                  (fl) =>
                    fl.Id ===
                    addPatientParams?.idTaaholDifault
                )[0]?.Name
              ),
            },
          ]}
        />
      ),
      name: 'idTaahol',
      required: true,
    },
    {
      element: (
        <EditableMuiDatePicker
          Placeholder={FindLangKey(
            'save-patients-for-visit-form-input-birth-date'
          )}
          isEnglish={i18next?.language === 'en'}
          disableInit={true}
          initialValue={
            gatheredData?.BirthDate || undefined
          }
        />
      ),
      name: 'BirthDate',
      required: true,
    },

    // {
    //   element: (
    //     <EditableCustomizableAutoComplete
    //       label={FindLangKey(
    //         'save-patients-for-visit-form-input-country-birth'
    //       )}
    //       isEnglish={i18next?.language === 'en'}
    //       isSingle={true}
    //       SelectableDataArray={addPatientParams?.CountryList?.map(
    //         (el) => ({
    //           label: ArabicToPersian(el?.Name),
    //           id: el?.Id,
    //         })
    //       )}
    //       defaultValue={ArabicToPersian(
    //         addPatientParams?.CountryList?.filter(
    //           (fl) =>
    //             fl.Id ===
    //             Number(addPatientParams?.idCountryDefault)
    //         )[0]?.Name
    //       )}
    //     />
    //   ),
    //   name: 'codeOstanTavalod',
    //   required: true,
    // },

    // {
    //   element: (
    //     <EditableCustomizableAutoComplete
    //       label={FindLangKey(
    //         'complete-user-information-input-ostan-born'
    //       )}
    //       isEnglish={i18next?.language === 'en'}
    //       isSingle={true}
    //       SelectableDataArray={addPatientParams?.OstanList?.map(
    //         (el) => ({
    //           label: ArabicToPersian(el?.Name),
    //           id: el?.Id,
    //         })
    //       )}
    //       defaultValue={ArabicToPersian(
    //         addPatientParams?.OstanList?.filter(
    //           (fl) =>
    //             fl.Id ===
    //             Number(addPatientParams?.ostanCodeDefault)
    //         )[0]?.Name
    //       )}
    //     />
    //   ),
    //   name: 'codeOstanTavalod',
    //   required: true,
    // },
    {
      element: (
        <EditableCustomizableAutoComplete
          label={FindLangKey(
            'complete-user-information-input-city-born'
          )}
          isEnglish={i18next?.language === 'en'}
          SelectableDataArray={addPatientParams?.CityList?.map(
            (el) => ({
              label: ArabicToPersian(el?.Name),
              id: el?.Id,
            })
          )}
          defaultValue={ArabicToPersian(
            addPatientParams?.CityList?.filter(
              (fl) =>
                fl.Id ===
                (gatheredData?.idCityTavalod ||
                  addPatientParams?.idCityDifault)
            )[0]?.Name
          )}
          completeOutPut={true}
          idOutput={true}
        />
      ),
      name: 'idCityTavalod',
      required: true,
    },
    // {
    //   element: (
    //     <EditableCustomizableAutoComplete
    //       label={FindLangKey(
    //         'complete-user-information-input-city-live'
    //       )}
    //       isEnglish={i18next?.language === 'en'}
    //       isSingle={true}
    //       SelectableDataArray={addPatientParams?.CityList?.map(
    //         (el) => ({
    //           label: ArabicToPersian(el?.Name),
    //           id: el?.Id,
    //         })
    //       )}
    //       defaultValue={ArabicToPersian(
    //         addPatientParams?.CityList?.filter(
    //           (fl) =>
    //             fl.Id === addPatientParams?.idCityDifault
    //         )[0]?.Name
    //       )}
    //     />
    //   ),
    //   name: 'idCitySokonat',
    //   required: true,
    // },
    {
      element: (
        <EditablePersianSupportTextField
          label={FindLangKey('general-public-address')}
          Initialvalue={gatheredData?.Address || ''}
        />
      ),
      name: 'Address',
    },
    {
      element: (
        <EditablePersianSupportTextField
          label={FindLangKey(
            'save-patients-for-visit-form-input-postal-code'
          )}
          Initialvalue={gatheredData?.CodePosti || ''}
        />
      ),
      name: 'CodePosti',
    },

    {
      element: (
        <EditableCustomizableAutoComplete
          label={FindLangKey(
            'save-patients-for-visit-form-input-zone'
          )}
          isEnglish={i18next?.language === 'en'}
          SelectableDataArray={addPatientParams?.ManagheList?.map(
            (el) => ({
              label: ArabicToPersian(el?.Name),
              id: el?.Id,
            })
          )}
          defaultValue={ArabicToPersian(
            addPatientParams?.ManagheList?.filter(
              (fl) => fl.Id === gatheredData?.idMantaghe
            )[0]?.Name
          )}
          idOutput={true}
        />
      ),
      name: 'idMantaghe',
    },
    {
      element: (
        <EditableCustomizableSelect
          label={FindLangKey(
            'save-patients-for-visit-form-input-religion-list'
          )}
          isEnglish={i18next?.language === 'en'}
          isSingle={true}
          SelectableDataArray={addPatientParams?.ReligionList?.map(
            (el) => ({
              ItemContent: ArabicToPersian(el.Name),
              ItemValue: el.Id,
            })
          )}
          initialData={
            gatheredData
              ? [
                  {
                    ItemContent: ArabicToPersian(
                      addPatientParams?.ReligionList?.filter(
                        (fl) =>
                          fl.Id === gatheredData?.idReligion
                      )[0]?.Name
                    ),
                    ItemValue: ArabicToPersian(
                      addPatientParams?.ReligionList?.filter(
                        (fl) =>
                          fl.Id === gatheredData?.idReligion
                      )[0]?.Name
                    ),
                  },
                ]
              : [
                  {
                    ItemContent: ArabicToPersian(
                      addPatientParams?.ReligionList?.filter(
                        (fl) =>
                          fl.Id ===
                          addPatientParams?.idReligion
                      )[0]?.Name
                    ),
                    ItemValue: ArabicToPersian(
                      addPatientParams?.ReligionList?.filter(
                        (fl) =>
                          fl.Id ===
                          addPatientParams?.idReligion
                      )[0]?.Name
                    ),
                  },
                ]
          }
        />
      ),
      name: 'idReligion',
    },

    {
      element: (
        <EditablePersianSupportTextField
          label={FindLangKey(
            'complete-user-information-input-telephone'
          )}
          Initialvalue={gatheredData?.Telephon || ''}
        />
      ),
      name: 'Telephon',
    },
    {
      element: (
        <EditableCustomizableSelect
          label={FindLangKey(
            'save-patients-for-visit-form-input-blood-group'
          )}
          isEnglish={i18next?.language === 'en'}
          isSingle={true}
          SelectableDataArray={addPatientParams?.BlodGroupList?.map(
            (el) => ({
              ItemContent: ArabicToPersian(el.Name),
              ItemValue: el.Id,
            })
          )}
          initialData={
            gatheredData
              ? [
                  {
                    ItemContent: ArabicToPersian(
                      addPatientParams?.BlodGroupList?.filter(
                        (fl) =>
                          fl.Id ===
                          gatheredData?.idBlodGroup
                      )[0]?.Name
                    ),
                    ItemValue: ArabicToPersian(
                      addPatientParams?.BlodGroupList?.filter(
                        (fl) =>
                          fl.Id ===
                          gatheredData?.idBlodGroup
                      )[0]?.Name
                    ),
                  },
                ]
              : [
                  {
                    ItemContent: ArabicToPersian(
                      addPatientParams?.BlodGroupList?.filter(
                        (fl) =>
                          fl.Id ===
                          addPatientParams?.idBlodGroup
                      )[0]?.Name
                    ),
                    ItemValue: ArabicToPersian(
                      addPatientParams?.BlodGroupList?.filter(
                        (fl) =>
                          fl.Id ===
                          addPatientParams?.idBlodGroup
                      )[0]?.Name
                    ),
                  },
                ]
          }
        />
      ),
      name: 'idBlodGroup',
    },
    {
      element: (
        <EditableCustomizableAutoComplete
          label={FindLangKey(
            'save-patients-for-visit-form-input-job-list'
          )}
          isEnglish={i18next?.language === 'en'}
          isSingle={true}
          SelectableDataArray={addPatientParams?.ShoghlList?.map(
            (el) => ({
              label: ArabicToPersian(el.Name),
              id: el.Id,
            })
          )}
          defaultValue={ArabicToPersian(
            addPatientParams?.ShoghlList?.filter(
              (fl) =>
                fl.Id ===
                (gatheredData?.idJob ||
                  addPatientParams?.idReligion)
            )[0]?.Name
          )}
          idOutput={true}
        />
      ),
      name: 'idJob',
    },
    {
      element: (
        <EditableCustomizableAutoComplete
          label={FindLangKey(
            'save-patients-for-visit-form-input-education-list'
          )}
          isEnglish={i18next?.language === 'en'}
          isSingle={true}
          SelectableDataArray={addPatientParams?.TahsilatList?.map(
            (el) => ({
              label: ArabicToPersian(el.Name),
              id: el.Id,
            })
          )}
          defaultValue={ArabicToPersian(
            addPatientParams?.TahsilatList?.filter(
              (fl) =>
                fl.Id ===
                (gatheredData?.idTahsilat ||
                  addPatientParams?.idTahsilatDefault)
            )[0]?.Name
          )}
          idOutput={true}
        />
      ),
      name: 'idTahsilat',
    },
    {
      element: (
        <EditableCustomizableAutoComplete
          label={FindLangKey(
            'save-patients-for-visit-form-input-how-meet'
          )}
          isEnglish={i18next?.language === 'en'}
          isSingle={true}
          SelectableDataArray={addPatientParams?.NahveAshnaeList?.map(
            (el) => ({
              label: ArabicToPersian(el.Name),
              id: el.Id,
            })
          )}
          defaultValue={ArabicToPersian(
            addPatientParams?.NahveAshnaeList?.filter(
              (fl) => fl.Id === gatheredData?.idNahveAshnae
            )[0]?.Name
          )}
          idOutput={true}
        />
      ),
      name: 'idNahveAshnae',
    },
  ];

  return formData;
};

export default useGenerateFormData;
